<template>
  <div class="empty-container">
    <v-img max-height="250px" height="100%" width="100%" contain="true" src="https://anniblob.blob.core.windows.net/images/Grafik_Startseite_Digitale_Hilfsmittelberatung.webp" ></v-img>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>